import React from "react";
import styles from "./PreloaderComponent.module.scss";

export const PreloaderComponent: React.FC = () => {
    return (
        <div className={`${styles.preloader}`}>
            <div className={`${styles.preloaderSpinner}`}></div>
        </div>
    );
};
